export default __webpack_public_path__ + "static/media/assessment.f5e3aa03.png";